<template>
    <div>
    <app-toolbarcustom :app_title="data.title" app_menu="hrsptlist"></app-toolbarcustom>
    <v-progress-linear
    indeterminate
    color="fourth"
    rounded
    class="progress-fixed"
    v-if="loading.page"
    ></v-progress-linear>
    <v-card
    class="mt-15"
    outlined
    >
    <v-card-title class="body-2 font-weight-bold">Ringkasan Surat Perintah Transfer</v-card-title>
    <v-card-text class="caption">
        <v-row align="center">
            <v-col cols="6">ID</v-col><v-col cols="6" class="font-weight-bold">{{ form.letter_id }}</v-col>
            <v-col cols="6" class="mt-n5">Tipe</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.letter_key }}</v-col>
            <v-col cols="6" class="mt-n5">Status</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.letter_status_desc }}</v-col>
            <v-col cols="6" class="mt-n5 body-1 font-weight-bold">Total</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold green--text body-1">{{ $functions.NewFormatNumber(form.letter_total) }}</v-col>
        </v-row>
    </v-card-text>
    <template v-if="form.letter_status === 'F' || form.letter_status === 'P'">
        <v-row justify="center" class="mt-4 mb-2">
            <v-btn-toggle
                rounded
                class="bg-grey-lighten-4 pa-2"
                mandatory
                dense
                v-if="access.read === 1"
            >
                <v-btn
                class="mx-1"
                color="secondary"
                @click="Confirm('csv')"
                :disabled="form.letter_downloadcsv !== 'DOWNLOAD CSV'"
                >
                {{ form.letter_downloadcsv }}
                </v-btn>

                <v-btn
                class="white--text mx-1"
                color="fourth"
                @click="Confirm('pdf')"
                :disabled="form.letter_paymentvoucher !== 'PAYMENT VOUCHER'"
                >
                {{ form.letter_paymentvoucher }}
                </v-btn>

                <v-btn
                class="white--text mx-1"
                color="success"
                @click="Confirm('paid')"
                >
                PAID
                </v-btn>
            </v-btn-toggle>
        </v-row>
    </template>
    <template v-if="form.letter_status === 'R' && form.letter_app1user === $functions.UsersID()">
        <v-row
            align="center"
            justify="space-around"
            class="mt-2 mb-2"
        >
        <v-btn
        color="red"
        @click="Confirm('reject')"
        >
        TOLAK
        </v-btn>
        <v-btn
        color="primary"
        @click="Confirm('approve')"
        >
        SETUJU
        </v-btn>
        </v-row>
        </template>
    </v-card>
        <v-card
            class="mx-auto mb-2"
            max-width="344"
            outlined
            v-for="row in posts"
            :key="row.doc_id"
            @click="GoTo(row.doc_type,row.doc_id)"
        >
            <v-list-item three-line>
            <v-list-item-content>
                <div class="text-overline mb-4" v-if="row.doc_sdate !== row.doc_edate">
                {{ $functions.FormatDateIndoWithDayName(row.doc_sdate) }} s/d
                {{ $functions.FormatDateIndoWithDayName(row.doc_edate) }}
                </div>
                <div class="text-overline mb-4" v-else>{{ $functions.FormatDateIndoWithDayName(row.doc_sdate) }}</div>
                <div>
                    {{row.doc_remarks}}
                </div>
            </v-list-item-content>
            <v-list-item-avatar
                size="80"
                color="grey"
            >
                <img :src="row.doc_usersavatarurl">
            </v-list-item-avatar>
            </v-list-item>
           
            <v-card-actions>
            <small class="ml-2"><v-icon>money</v-icon> IDR {{ $functions.NewFormatNumber(row.doc_total) }}</small><v-spacer></v-spacer>
            <small>{{row.doc_usersname}}</small>
            </v-card-actions>
        </v-card>
    <v-card
    outlined
    >
    <v-card-title class="body-2 font-weight-bold">Timeline</v-card-title>
    <v-timeline
            align-top
            dense
          >
            <v-timeline-item
              color="green"
              small
            >
              <div>
                <div class="caption">
                    created:<strong> {{ form.letter_cuser }}</strong> &bull; {{ $functions.FormatDateTime(form.letter_cdate) }}
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              :color="$functions.FormatDateTime(form.letter_app1date)?'green':'yellow'"
              small
              v-if="form.letter_app1user && form.letter_app1date !== '1900-01-01'"
            >
              <div>
                <div class="caption">
                    leader:<strong> {{ form.letter_app1user }}</strong> &bull; {{ $functions.FormatDateTime(form.letter_app1date) }}
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              :color="$functions.FormatDateTime(form.letter_financedate)?'green':'yellow'"
              small
              v-if="form.letter_financeuser"
            >
              <div>
                <div class="caption">
                    keuangan:<strong> {{ form.letter_financeuser }}</strong> &bull; {{ $functions.FormatDateTime(form.letter_financedate) }}
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              color="red"
              small
              v-if="form.letter_rejectuser"
            >
              <div>
                <div class="caption">
                    reject:<strong> {{ form.letter_rejectuser }}</strong>&bull;{{ $functions.FormatDateTime(form.letter_rejectdate) }}
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
    </v-card>
    <v-alert
    border="left"
    colored-border
    color="secondary"
    elevation="2"
    v-if="form.letter_notes"
    >
    <div v-html="form.letter_notes"></div>
    </v-alert>
    <div class="mt-10">&nbsp;</div>
    <v-dialog v-model="confirm.dialog" max-width="490" persistent>
        <v-card>
            <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
            <v-card-text>
                {{confirm.text}}
                <v-text-field 
                    v-model="confirm.notes"
                    prepend-inner-icon="notes"
                    placeholder="Catatan"
                    label="Catatan"
                    required
                    solo-inverted
                    outlined
                    class="mt-3"
                    id="confirmnotes"
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="payment.dialog" max-width="490" persistent>
        <v-card>
            <v-card-title class="secondary headline white--text">{{payment.title}}</v-card-title>
            <v-card-text>
                  <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="progress-fixed"
                    v-if="loading.spt"
                    ></v-progress-linear>
                <v-card
                    class="mx-auto mb-2"
                    max-width="344"
                    outlined
                    v-for="row in postsdetail"
                    :key="`${row.doc_usersaccountno}-${row.doc_usersaccountname}`"
                >
                    <v-list-item three-line>
                    <v-list-item-content>
                        <div class="text-overline">{{ row.doc_usersaccountbankdesc }}</div>
                        <div class="text-overline">{{ row.doc_usersaccountno }}</div>
                        <div class="text-overline">{{ row.doc_usersaccountname }}</div>
                        <div>
                            {{row.doc_remarks}}
                        </div>
                        <v-btn text small class="primary white--text" @click="DownloadPDF(row.doc_type,row.doc_sino,row.doc_usersaccountno, row.doc_userscompany)">CETAK</v-btn>
                    </v-list-item-content>
                    <v-list-item-avatar
                        size="80"
                        color="grey"
                    >
                        <img :src="row.doc_usersavatarurl">
                    </v-list-item-avatar>
                    </v-list-item>
                    <v-card-actions>
                    <small class="ml-2 red--text font-weight-black"><v-icon>money</v-icon> IDR {{ $functions.NewFormatNumber(row.doc_total) }}</small><v-spacer></v-spacer>
                    <small>{{row.doc_usersname}}</small>
                    </v-card-actions>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" outlined @click.stop="payment.dialog = false">{{payment.close}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="paid.dialog" max-width="490" persistent>
        <v-card>
            <v-card-title class="secondary headline white--text">{{paid.title}}</v-card-title>
            <v-card-text>
                <v-row>
                    <!-- ID -->
                    <v-col cols="12" sm="6" md="12" class="mt-2">
                        <v-dialog
                        ref                 ="dialog_letter_paymentdate"
                        v-model             ="modal.letter_paymentdate"
                        :return-value.sync  ="form.letter_paymentdate"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="letter_paymentdate_value"
                            label               ="Tanggal Bayar"
                            prepend-icon        ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_letter_paymentdate"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.letter_paymentdate" :min="$functions.PastDate(30)" :max="$functions.PastDate(0)" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.letter_paymentdate = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('letter_paymentdate',form.letter_paymentdate)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                     <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.letter_paymentrefno"
                            prepend-icon="notes"
                            placeholder="Berikan Nomor Referensi Bayar"
                            label="Nomor Referensi Bayar *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n6">
                        <v-text-field 
                            v-model="form.letter_notes"
                            prepend-icon="notes"
                            placeholder="Catatan"
                            label="Catatan *"
                            required
                            solo-inverted
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" outlined @click.stop="paid.dialog = false">{{paid.close}}</v-btn>
                <v-btn id="dialog_paid_true" color="primary" outlined :disabled = "paid.ok !== 'OK' ? true:false" @click="LoadingPaid">{{paid.ok}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    <app-snackbar 
        :dialog="snackbar.dialog"
        :color="snackbar.color"
        :text="snackbar.text"
        :timeout="snackbar.timeout"
        @close="snackbar.dialog = false"
    ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            title: '',
            posts: [],
            postsdetail: [],
            loading: {
                page: false,
                spt: false,
            },
            data: {
                title: ''
            },
            form: {
                letter_id: '',
                letter_key: '',
                letter_total: 0,
                letter_cdate: '',
                letter_cuser: '',
                letter_app1date: '',
                letter_app1user: '',
                letter_app2date: '',
                letter_app2user: '',
                letter_financedate: '',
                letter_financeuser: '',
                letter_rejectdate: '',
                letter_rejectuser: '',
                letter_status: '',
                letter_status_desc: '',
                letter_downloadcsv: 'DOWNLOAD CSV',
                letter_paymentvoucher: 'PAYMENT VOUCHER',
                letter_paymentdate: new Date().toISOString().substr(0, 10),
                letter_paymentrefno: '',
                letter_paymentrefno_rules: [v => !!v || 'Mohon isi Nomor Referensi Bayar'],
                letter_notes: '',
            },
            payment: {
                dialog: false,
                title: 'PAYMENT VOUCHER',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                notes: '',
            },
            paid: {
                dialog: false,
                title: 'PROSES BAYAR',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                notes: '',
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                notes: '',
            },
            modal: {
                letter_paymentdate: false,
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
            access: {
                read: 0
            }
        }),
        created() {
            this.FirstLoad()
        },
        computed: {
            letter_paymentdate_value () {
                return this.form.letter_paymentdate ? this.$moment(this.form.letter_paymentdate).format('LL') : ''
            },
        },
        methods: {
            Access () {
                let modul = 'paymentvoucher'
                let formdata = {
                    menu_id: modul,
                    users_id: this.$functions.UsersID(),
                    order_by: 'menu_id',
                    order_type: 'ASC',
                    flag: 'mobileapp',
                    limit: this.limit,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMenuUser'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let priv = response.data
                    if (priv.length > 0) {
                        if (priv[0].usersmenu_read === 1) {
                            this.access.read = priv[0].usersmenu_read
                        }
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 0)
                })
            },
            FirstLoad() {
                this.Summary()
                this.Detail()
                this.Access()
            },
            Summary () {
                this.loading.page = true
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                let formdata = {
                  letter_id: decode,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.form.letter_id = feedback[0].letter_id
                            this.form.letter_key = feedback[0].letter_key
                            this.form.letter_total = feedback[0].letter_total
                            this.form.letter_cdate = feedback[0].letter_cdate
                            this.form.letter_cuser = feedback[0].letter_cuser
                            this.form.letter_app1date = feedback[0].letter_app1date
                            this.form.letter_app1user = feedback[0].letter_app1user
                            this.form.letter_app2date = feedback[0].letter_app2date
                            this.form.letter_app2user = feedback[0].letter_app2user
                            this.form.letter_financedate = feedback[0].letter_financedate
                            this.form.letter_financeuser = feedback[0].letter_financeuser
                            this.form.letter_rejectdate = feedback[0].letter_rejectdate
                            this.form.letter_rejectuser = feedback[0].letter_rejectuser
                            this.form.letter_status = feedback[0].letter_status
                            this.form.letter_status_desc = feedback[0].letter_status_desc
                            this.loading.page = false
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                            this.loading.page = false
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                        this.loading.page = false
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            Detail () {
                this.loading.page = true
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                this.data.title = decode
                let formdata = {
                  doc_sino: decode,
                  doc_company: this.$functions.UsersCompany(),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListDetailSPT'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts = feedback
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            DetailPayment () {
                this.loading.spt = true
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                this.data.title = decode
                let formdata = {
                  doc_sino: decode,
                  doc_company: this.$functions.UsersCompany(),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListDetailSPTGroupByAccountNo'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.postsdetail = feedback
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.spt = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.spt = false
                })
            },
            CheckHR () {
                this.loading.page = true
                let formdata = {
                  users_type: 'HR-MGR',
                  flag: 'mobileapp',
                  users_company: this.$functions.UsersCompany(),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersShort'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.form.hr_user = feedback[0].users_id
                            this.loading.page = false
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                            this.loading.page = false
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                        this.loading.page = false
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            Confirm (flag) {
                if (flag === 'approve') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Setuju'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                } else if (flag === 'finance') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Setuju Keuangan'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                } else if (flag === 'reject') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Tolak'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                } else if (flag === 'csv') {
                    this.form.letter_downloadcsv = 'Loading...'
                    this.url_type = flag
                    this.confirm.notes = '-'
                    this.Write()
                } else if (flag === 'pdf') {
                    this.payment.dialog  = true
                    this.DetailPayment()
                } else if (flag === 'paid') {
                    this.paid.dialog  = true
                }
            },
            Loading () {
                if (this.confirm.notes === '') {
                    this.SnackBar(true, 'success', 'Mohon isi catatan', 3000)
                    setTimeout(function(){
                    document.getElementById('confirmnotes').focus()
                    }, 500)
                } else {
                    this.confirm.ok = 'Loading...'
                    this.Write()
                }
            },
            LoadingPaid() {
                let validation = ''
                if (this.form.letter_paymentdate === '') {
                    validation = 'Mohon isi Tanggal Bayar'
                }
                if (this.form.letter_refno === '') {
                    validation += 'Mohon isi Tanggal Bayar'
                }
                if (this.form.letter_notes === '') {
                    validation += 'Mohon isi Catatan'
                }
                if (validation !== '') {
                    this.SnackBar(true, 'error', validation, 3000)
                } else {
                    this.paid.ok = 'Loading...'
                    this.url_type= 'paid'
                    this.Write()
                }
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  letter_id: this.form.letter_id,
                  letter_paymentdate: this.form.letter_paymentdate,
                  letter_paymentrefno: this.form.letter_paymentrefno,
                  letter_notes: this.confirm.notes,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            let flag = ''
                            if (this.url_type === 'approve') {
                                flag = 'Setuju'
                                this.form.letter_status = 'F'
                                this.form.letter_status_desc = 'UnApprove Finance'
                            } else if (this.url_type === 'reject') {
                                flag = 'Tolak'
                                this.form.letter_status = 'J'
                                this.form.letter_status_desc = 'Reject'
                            } else if (this.url_type === 'hr') {
                                flag = 'Setuju HR'
                                this.form.letter_status = 'A'
                                this.form.letter_status_desc = 'Approve'
                            } else if (this.url_type === 'paid') {
                                flag = 'Paid'
                                this.form.letter_status = 'P'
                                this.form.letter_status_desc = 'Paid'
                            }
                            this.SnackBar(true, 'success', flag+' Sukses', 3000)
                            this.confirm.dialog  	 = false
                            this.confirm.text 	 	 = 'Ok'
                            if (this.url_type !== 'csv') {
                                this.$router.push({name: 'hrsptlist'})
                            } else {
                                this.form.letter_downloadcsv = 'DOWNLOAD CSV'
                                window.open(feedback[0].feedback_url)
                            }
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.paid.ok = 'OK'
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.paid.ok = 'OK'
                })
            },
            GoTo (type,id) {
                let url = ''
                if (type === 'medical') {
                    url = 'employeemedicaldetail'
                } else if (type === 'transportation') {
                   url = 'employeetransportationdetail'
                } else if (type === 'entertainment') {
                   url = 'employeeentertainmentdetail'
                }
                this.$router.push({name: url,params:{id:this.$functions.EncodeUrl(id)}})
            },
            DownloadPDF(type, sino, accountno, company) {
                let url = this.$functions.AppDoc() + '/modul/mod_documents/doc_payment_voucher.php?doc_type='+type+'&doc_sino='+sino+'&doc_usersaccountno='+accountno+'&doc_company='+company
                window.open(url, '_blank')
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'letter_paymentdate':
                		this.$refs.dialog_letter_paymentdate.save(value)
                        this.form.letter_paymentdate = this.$moment(value).format('YYYY-MM-DD')
                    break
                }
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>